
import React, { useEffect, useState } from 'react';


import { myTheme } from '../../../assets/styles/my-theme';

import { IFile } from '../../../shared/interfaces';
import {
    Selection, CheckboxVisibility, DetailsList, DetailsListLayoutMode, DocumentCard, DocumentCardActions,
    DocumentCardDetails, DocumentCardPreview, DocumentCardTitle, DocumentCardType, getTheme,
    IButtonProps, Icon, IDocumentCardPreviewProps, IDocumentCardStyles, ITheme, mergeStyleSets,
    SelectionMode, Text, IRenderFunction, IDetailsRowProps, IDetailsGroupRenderProps, IGroup, EventGroup
} from '@fluentui/react';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import { RouteComponentProps } from 'react-router-dom';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RootState } from '../../../store';
import { useSelector } from 'react-redux';


const theme: ITheme = getTheme();
const { fonts } = theme;
const { palette } = myTheme;


const classNames = mergeStyleSets({
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'inherit'
        },
    ],
    itemDimension: {
        fontSize: fonts.small.fontSize,
        color: palette.neutralTertiary,
        marginBottom: 10,
        padding: '0px 16px'
    },
    headerAndFooter: {
        padding: '15px',
        // Overlay the sizer bars
        position: 'relative',
        zIndex: 100,
    },
    headerTitle: [
        fonts.large,
        {
            color: palette.neutralPrimary,
        }
    ],
    emptyColumn: {}
});




export interface MailProtocolWizardFileListProps {
    onFileClick: (item) => void
    onRemoveFileClick?: (ev, item) => void

}
type Props = MailProtocolWizardFileListProps & RouteComponentProps

const MailProtocolWizardFileList: React.FunctionComponent<Props> = props => {
    const selectFileListOptions = (state: RootState) => state.mailProtocolWizardReducer.fileListOptions;
    const fileListOptions = useSelector(selectFileListOptions);

    const [fileSelection, setFileSelection] = useState<Selection>(new Selection({
        onSelectionChanged: () => { }
    }));

    useEffect(() => {
        if (fileListOptions) {
            fileSelection.setIndexSelected(0, true, false);
            props.onFileClick(fileListOptions[0]);

        }
        const events = new EventGroup(undefined);
        events.on(fileSelection, 'change', (ev) => {
            const selectedFile = fileSelection.getSelection()[0] as IFile;
            let someFileIsLoading = fileListOptions?.findIndex(el => el.loading === true) !== -1;
            if (selectedFile && selectedFile.enabled && !someFileIsLoading) {
                props.onFileClick(selectedFile);
            }
            else if (!selectedFile) {
                props.onFileClick(null);
            }
        });

        return () => {
            // Anything in here is fired on component unmount.
            events.dispose();
        }


    }, [fileListOptions]);

    const fileRenderIcon = (item) => {
        if (item.loading) {
            return <div style={{ fontSize: 20 }}> <FontAwesomeIcon icon={['fal', 'circle-notch']} spin /></div>;
        }
        else
            return <Icon {...getFileTypeIconProps({ extension: item.extension, size: 20 })} />;

    }




    const fileRenderCell = (item: any) => {
        const documentCardSyles: Partial<IDocumentCardStyles> = {
            root: {
                height: 65,
                backgroundColor: !item.enabled ? 'rgb(243, 242, 241)' : 'unset',
                color: !item.enabled ? 'rgb(161, 159, 157)' : 'unset',
                '&:hover': {
                    cursor: item.enabled ? 'pointer' : 'unset',

                }
            },

        }

        const previewPropsUsingIcon: IDocumentCardPreviewProps = {
            previewImages: [
                {
                    previewIconProps: {
                        children: fileRenderIcon(item)
                    },
                    width: 63,

                }
            ],
            styles: {
                previewIcon: { backgroundColor: palette.neutralLighterAlt },
            },

        };
        let actions: IButtonProps[] = [];
        if (props.onRemoveFileClick) {
            actions.push({
                iconProps: { iconName: 'Delete' },
                onClick: (ev) => props.onRemoveFileClick!(ev, item),
                ariaLabel: 'Elimina',
            })
        }
        return (
            <DocumentCard
                aria-label={item.fileName}
                type={DocumentCardType.compact}
                styles={documentCardSyles}
            >
                <DocumentCardPreview {...previewPropsUsingIcon} />
                <DocumentCardDetails>
                    <DocumentCardTitle title={item.fileName} className={classNames.itemName} />
                    <div className={classNames.itemDimension}>{AppUtilities.GetDimensionFileString(item)}</div>
                </DocumentCardDetails>
                <DocumentCardActions
                    actions={actions} />

            </DocumentCard>
        );
    };


    const onRenderDailsListRow: IRenderFunction<IDetailsRowProps> = (rowProps, defaultRender) => {

        rowProps!.onRenderDetailsCheckbox = (props, defaultRender) => {
            return defaultRender!({ ...props! });
        };
        if (!rowProps!.item.enabled) {
            rowProps!.checkboxVisibility = CheckboxVisibility.hidden;
        }

        rowProps!.onRenderItemColumn = fileRenderCell;

        rowProps!.className = !rowProps!.item.enabled ? 'disabled' : "";
        rowProps!.styles = {
            root: {
                border: 'none !important',
                '.ms-GroupSpacer': {
                    width: '0px !important'
                },

                '&.disabled': {
                    '.ms-GroupSpacer': {
                        width: '36px !important'
                    }
                },
                '.ms-DetailsRow-check': {
                    height: '100%',
                    width: 36
                },
                '.ms-DetailsRow-fields .ms-DetailsRow-cell': {
                    paddingLeft: 0

                },
                
            },
            cell: { padding: '0px' },
            fields: {
                flex: '1 1 auto'
            },

        }
        let someFileIsLoading = fileListOptions?.findIndex(el => el.loading === true) !== -1;

        return <div data-selection-toggle="true" data-selection-disabled={someFileIsLoading || !rowProps!.item.enabled}>{defaultRender!({ ...rowProps! })}</div>;
    }

    const onRenderGroupHeader: IDetailsGroupRenderProps['onRenderHeader'] = props => {
        if (props) {
            return (
                <div className={classNames.headerAndFooter}>
                    <div className={classNames.headerTitle}>{`${props.group!.name}`}</div>

                </div>
            );
        }

        return null;
    };
    const showFileList = () => {
        let groups: IGroup[] = [];
        if (fileListOptions && fileListOptions.length > 0) {
            if (fileListOptions.findIndex(el => el.fileName === 'Corpo della mail.pdf') !== -1) {
                groups.push(...[{
                    key: 'pdfMailFile',
                    name: 'Corpo della mail',
                    startIndex: 0,
                    count: 1,
                    isShowingAll: false
                },
                {
                    key: 'allegati',
                    name: 'File della mail',
                    startIndex: 1,
                    count: fileListOptions.length - 1
                }])
            }
            else {
                groups.push(
                    {
                        key: 'allegati',
                        name: 'File della mail',
                        startIndex: 0,
                        count: fileListOptions.length
                    })
            }


            return <DetailsList
                items={fileListOptions}
                groups={groups}
                groupProps={{
                    onRenderHeader: onRenderGroupHeader,
                }}

                columns={[{
                    key: 'file',
                    fieldName: '',
                    name: '',
                    minWidth: 100,
                }
                ]}
                isHeaderVisible={false}
                onRenderRow={onRenderDailsListRow}
                layoutMode={DetailsListLayoutMode.justified}
                selection={fileSelection}
                selectionPreservedOnEmptyClick={true}
                selectionMode={SelectionMode.single}
                checkboxVisibility={CheckboxVisibility.onHover}
                className="mail-protocol-file-list"
            />
        }
        else
            return <Text nowrap block>
                Nessun file presente
            </Text>
    }

    return <React.Fragment>

        {showFileList()}

    </ React.Fragment>

};


export default MailProtocolWizardFileList;



